import React, { useEffect, useRef } from 'react';

/**
 * Prikaz isečka screenshot-a oko telefonskog broja (normalizovane koordinate 0–1).
 */
const PhoneCropPreview = ({ imageSrc, cropBox, className = '' }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas || !imageSrc || !cropBox) return undefined;

    const w = Number(cropBox.w ?? cropBox.width);
    const h = Number(cropBox.h ?? cropBox.height);
    if (!Number.isFinite(w) || !Number.isFinite(h) || w <= 0 || h <= 0) return undefined;

    let cancelled = false;
    const img = new Image();
    img.onload = () => {
      if (cancelled) return;
      const ctx = canvas.getContext('2d');
      if (!ctx) return;

      const sx = Math.max(0, Number(cropBox.x) || 0) * img.width;
      const sy = Math.max(0, Number(cropBox.y) || 0) * img.height;
      const sw = Math.min(img.width - sx, w * img.width);
      const sh = Math.min(img.height - sy, h * img.height);

      const displayW = Math.max(120, Math.min(280, sw));
      const scale = displayW / sw;
      const displayH = Math.max(28, sh * scale);

      canvas.width = displayW;
      canvas.height = displayH;
      ctx.imageSmoothingEnabled = true;
      ctx.drawImage(img, sx, sy, sw, sh, 0, 0, displayW, displayH);
    };
    img.src = imageSrc;

    return () => {
      cancelled = true;
    };
  }, [imageSrc, cropBox]);

  if (!imageSrc || !cropBox) return null;

  return (
    <canvas
      ref={canvasRef}
      className={`rounded border border-amber-600/60 bg-black/40 ${className}`}
      aria-label="Uvećani isečak broja telefona sa slike"
    />
  );
};

export default PhoneCropPreview;
